import styled from 'styled-components';
import { Row, Col } from 'react-flexbox-grid';
import Icon from '../Icon';

import { COLORS } from '../../../../utils/styles';

export const Left = styled(Col)`
  background-color: ${COLORS.red};
  display: inherit;
  height: 100%;
`;

export const Container = styled(Row)`
  height: 6rem;
  padding: 0.5rem;
`;

export const InfoIcon = styled(Icon)`
  margin: auto;
`;

export const MessageContainer = styled.span`
  margin: auto;
  color: ${COLORS.naturalGray};
`;

export const Right = styled(Col)`
  background-color: ${COLORS.athensGray};
  height: 100%;
  display: inherit;
`;



// WEBPACK FOOTER //
// ./src/views/common/components/Notification/styled-components.js